import App from '../src/modules/App';

import '../src/modules/App/styles.css';

export default App;
